/*
 * The announcer element (REUSE J1): a visually hidden live region whose text change is what a
 * screen reader speaks. There is exactly one polite region in the application (A31) — the shell
 * mounts it and everything else routes through the shell, because two regions racing produce
 * interleaved speech.
 *
 * `role="alert"` (mode "assertive") is reserved for failures; a new message is never assertive.
 */

import type { PropsWithChildren } from "react"

interface LiveRegionProps {
	mode?: "polite" | "assertive"
	/** The region's name in a screen reader's landmark list; already translated. */
	label?: string
}

export function LiveRegion({
	mode = "polite",
	label,
	children,
}: PropsWithChildren<LiveRegionProps>) {
	return (
		<div
			aria-live={mode}
			aria-atomic="true"
			aria-label={label}
			role={mode === "assertive" ? "alert" : "status"}
			className="tb-visually-hidden"
		>
			{children}
		</div>
	)
}
